import styled from 'styled-components';

export const ConfirmDeleteButton = styled.button`
  padding: 0;
  background: inherit;
  color: inherit;
  border: none;
  cursor: pointer;
`;
